"use strict";
/**
 * Created by rouven on 02.03.17.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var redux_form_1 = require("redux-form");
var SelectClassic = function (_a) {
    var name = _a.name, className = _a.className, options = _a.options;
    var optionTags = Object
        .keys(options)
        .map(function (optionKey) { return react_1["default"].createElement("option", { value: optionKey, key: optionKey }, options[optionKey]); });
    return (react_1["default"].createElement(redux_form_1.Field, { name: name, component: "select", className: className },
        react_1["default"].createElement("option", null, "Bitte ausw\u00E4hlen"),
        optionTags));
};
exports["default"] = SelectClassic;
